import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'

const state = {
  uploadData: {},
  nextExecuteDate: '',
  currentProductAttribute: [],
  message: {
    content: '',
    type: ''
  }
}

const actions = {

  async getProductAttributeDate ({ state, commit }) {
    commit('init', Constants.getContract('product_attribute_date'))
  },

  /**
   * prodcut attributeデータ取得
   */
  async getCurrentProductAttribute ({ state, commit }) {
    const response = await ApiManager.request('ProductAttribute').productAttributeParentList()
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setCurrentProductAttribute', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
    }
  },

  async upload ({ state, commit }, payload) {
    this.dispatch('loading/loadingPagePlus')
    let formData = new FormData()
    formData.append('product_attribute_date', payload.product_attribute_date)
    formData.append('excel_product', payload.excel_product)
    const response = await ApiManager.request('ProductAttribute').productAttributeUpload(
      payload.product_attribute_date, payload.excel_product
      , {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    const message = {
      type: 'success',
      content: ''
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setUploadData', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      message.type = 'error'
      message.content = response.data.data.message
    }
    commit('setMessage', message)
    this.dispatch('loading/loadingPageMinus')
  },

  async save ({ state, commit }, excelProduct) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('ProductAttribute').productAttributeSave(JSON.stringify(state.uploadData), excelProduct
      , {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    const message = {
      type: 'success',
      content: '商品属性が正常にアップロードしました。'
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setNextExecuteDate', state.uploadData.product_attribute_date)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      message.type = 'error'
      message.content = response.data.data.message
    }
    commit('setMessage', message)
    this.dispatch('loading/loadingPageMinus')
  },

  async delete ({ state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('ProductAttribute').productAttributeDelete()
    const message = {
      type: 'success',
      content: ''
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setNextExecuteDate', '')
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      message.type = 'error'
      message.content = response.data.data.message
    }
    commit('setMessage', message)
    this.dispatch('loading/loadingPageMinus')
  }
}

const mutations = {
  init (state, data) {
    // 初期ローディングの終了
    state.nextExecuteDate = data
  },
  setMessage (state, data) {
    state.message = data
  },
  setUploadData (state, data) {
    state.uploadData = data
  },
  setNextExecuteDate (state, data) {
    state.nextExecuteDate = data
  },
  setCurrentProductAttribute (state, data) {
    state.currentProductAttribute = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
